import { Injectable } from "@angular/core";
import { HhsgSharedApplication } from "../models/application.model";
import { HhsgSharedClient } from "../models/client.model";
import { HhsgSharedCorporation } from "../models/corporation.model";
import { HhsgSharedConfigService } from "./config.service";
import { HhsgSharedHttpService } from "./http.service";

@Injectable()
export class HhsgSharedStuderService {
    private readonly _apiServer: string;
	private readonly _controllerName = 'Studer';

	constructor(private _configService: HhsgSharedConfigService, private _httpService: HhsgSharedHttpService) { 
        this._apiServer = _configService.appSettings.stsServer;
    }

    public async getActiveStuderClientsForCorporationUntracked(corporationId: number): Promise<HhsgSharedClient[]> {
		return this._httpService.doGetRequestAsync(this._apiServer, this._controllerName, `GetActiveStuderClientsForCorporationUntracked/${corporationId}`);
	}

    public async getAllActiveStuderClientsForUser(): Promise<HhsgSharedClient[]> {
		return this._httpService.doGetRequestAsync<HhsgSharedClient[]>(this._apiServer, this._controllerName, 'GetActiveStuderClientsForUser');
	}

    public async getAllStuderActiveApplications(clientId: number): Promise<HhsgSharedApplication[]> {
		return this._httpService.doGetRequestAsync<HhsgSharedApplication[]>(this._apiServer, this._controllerName, `GetStuderApplicationsForClient/${clientId}`);
	}

    public async getClientIdForStuderOrganization(organizationId: number): Promise<number> {
		return this._httpService.doGetRequestAsync(this._apiServer, this._controllerName, `GetClientIdForStuderOrganization/${organizationId}`);
	}

    public async getStuderChildApplicationUserId(userId: number): Promise<number> {
		return await this._httpService.doGetRequestAsync(this._apiServer, this._controllerName, `GetStuderChildApplicationUserId/${userId}`);
	}

	public async getStuderCorporations(): Promise<HhsgSharedCorporation[]> {
		return this._httpService.doGetRequestAsync(this._apiServer, this._controllerName, 'GetStuderCorporations');
	}

    public async getStuderClients(): Promise<HhsgSharedClient[]> {
		return this._httpService.doGetRequestAsync(this._apiServer, this._controllerName, 'GetStuderClients');
	}

	public async getStuderCorporationsForUser(userId: number): Promise<HhsgSharedCorporation[]> {
		return this._httpService.doGetRequestAsync(this._apiServer, this._controllerName, `GetStuderCorporationsForUser/${userId}`);
	}

    public async handleUserArchive(employeeId: number, isArchived: boolean):Promise<any> {
		return await this._httpService.doPostRequestAsync(this._apiServer, this._controllerName, `HandleStuderUserActiveStatus/${employeeId}/${isArchived}`, null);
	}

    public async isUserSGPortalAdmin(): Promise<boolean> {
		return await this._httpService.doGetRequestAsync<boolean>(this._apiServer, this._controllerName, 'IsUserSGPortalAdmin');	
	}
}